import React, { Fragment } from 'react';

import { DEFAULT_ESCROW_PAGE } from 'spa/constants/HeaderConstants';
import HeaderV3 from 'spa/containers/HeaderV3';
import V2KYC from './V2KYC';

const V2KYCContainer = ({ isMobile }) => (
  <Fragment>
    <HeaderV3
      pageType={DEFAULT_ESCROW_PAGE}
      title={'Verify your identity'}
      toggleSidebar={() => {
        isMobile;
      }}
    />
    <div className="section--mid kyc-page">
      <div className="section-container">
        <V2KYC />
      </div>
    </div>
  </Fragment>
);

export default V2KYCContainer;
